(() => {
  const url = new URL(window.location.href);
  const preview = url.searchParams.get('preview_theme_id');
  document.querySelectorAll('[data-sw-character-link]').forEach(link => {
    const target = new URL(link.href);
    if (preview) target.searchParams.set('preview_theme_id', preview);
    const max = url.searchParams.get('filter.v.price.lte');
    const min = url.searchParams.get('filter.v.price.gte');
    if (max === '24.99') target.searchParams.set('sw_price', 'under25');
    else if (min === '25' && max === '50') target.searchParams.set('sw_price', '25to50');
    else if (min === '50') target.searchParams.set('sw_price', 'over50');
    link.href = target.href;
  });
  const legacy = url.searchParams.get('filter.v.option.size');
  const legacyCharacters = ['Astra', 'Chase', 'Crystal', 'Dizzy', 'Donnie', 'Donnie A', 'Donnie B', 'Flip', 'GOLDEN BOY', 'Jerome', 'Jett', 'LEO', 'Mira', 'Paul', 'SUNNY'];
  if (legacyCharacters.includes(legacy) && url.searchParams.get('view') === 'christmas') {
    const target = document.querySelector('[data-sw-character-link]');
    if (!target) return;
    const destination = new URL(target.href);
    destination.searchParams.set('sw_character', legacy.replace(/^Donnie [AB]$/, 'Donnie').replace(/^GOLDEN BOY$/, 'Golden Boy').replace(/^SUNNY$/, 'Sunny').replace(/^LEO$/, 'Leo'));
    window.location.replace(destination.href);
  }
})();
